module.exports = __webpack_public_path__ + "static/MYS-77ff9b9ac048642a1d7b7f2d24403c86.jpg";